import { render, staticRenderFns } from "./RunningGoodsList.vue?vue&type=template&id=a9f3c3cc"
import script from "./RunningGoodsList.vue?vue&type=script&lang=js"
export * from "./RunningGoodsList.vue?vue&type=script&lang=js"
import style0 from "./RunningGoodsList.vue?vue&type=style&index=0&id=a9f3c3cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports